import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Avvecklad verksamhet",
  "Spare part list": "Reservdelslista",
  "Download Excel": "Ladda ner Excel",
  "Recent search list": "Lista över senaste sökningar",
  "No data": "Inga uppgifter",
  "spare part": "Reservdel",
  "none": "ingen",
  "no value": "inget värde",
  "No results found": "Inga resultat hittades",
  "Spare parts for": "Reservdelar för",
  "Could not load cumulated data": "Kunde inte ladda ackumulerade data",
  "commissioning part": "idrifttagande del",
  "wear part": "slitdel",
  "Search": "Sök",
  "Tk": "Tk",
  "Spare part number": "Reservdelsnummer",
  "drawing": "ritning",
  "Products for": "Produkter för",
  "Available": "Tillgänglig",
  "MM": "MM",
  "The entered order code is invalid": "Den angivna orderkoden är ogiltig",
  "Recommended": "Rekommenderas",
  "No data available for the entered search parameters": "Ingen data tillgänglig för de angivna sökparametrarna",
  "Search spare parts": "Sök reservdelar",
  "Order code / product root / serial number": "Orderkod / produktrot / serienummer",
  "Characteristic": "Karaktäristisk",
  "Please enter an order code": "Vänligen ange en beställningskod",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "När det gäller kvalitets- och säkerhetsaspekter rekommenderar Endress+Hauser starkt att endast originalreservdelar från Endress+Hauser används. \nInstrumentet får endast underhållas och repareras av kvalificerad personal. \nEnhetens dokumentation tillämpliga standarder och lagkrav samt eventuella certifikat måste följas!",
  "Maintenance advice": "Råd om underhåll",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "För vilken/vilka produkt(er) kan min reservdel användas? Genom att fylla i reservdelens beställningskod (t.ex. 71002865 eller XPD0024) visas de relevanta enheter som reservdelen kan användas i.",
  "tool": "verktyg",
  "Production numbers": "Produktionssiffror",
  "New alternative": "Nytt alternativ",
  "There are no items selected. Please use the checkboxes to make your selection": "Det finns inga objekt valda. Vänligen använd kryssrutorna för att göra ditt val",
  "Service segmentation": "Segmentering av tjänster",
  "Seg": "Seg",
  "Valid": "Giltig",
  "Pos": "Pos",
  "Value": "Värde",
  "service segmentation 2": "Delar som kräver grundläggande kunskaper. Framgångsrikt deltagande i E+H:s grundutbildning är en förutsättning.",
  "Phase out date": "Datum för utfasning",
  "service segmentation 1": "Delar som kräver grundläggande kunskaper.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Vilka reservdelar finns tillgängliga för min produkt? Genom att fylla i orderkoden (t.ex. FTC260-AA2A1 eller PMC51-BA21JB1CGBTDJB) eller produktnumret (t.ex. FTC260 eller 83F50) visas relevanta reservdelar.",
  "Set filter": "Ställ in filter",
  "Search date": "Sökdatum",
  "Group": "Grupp",
  "Warning": "Varning",
  "Description": "Beskrivning",
  "Cancel": "Avbryt",
  "service segmentation 4": "Delar för reparation i fabriken. Expertkunskaper är obligatoriska.",
  "service segmentation 3": "Delar som kräver specialiserad kunskap. Framgångsrikt deltagande i E+H:s avancerade utbildning är en förutsättning.",
  "Drawing Position Number": "Ritning Position Nummer",
  "Spare parts search": "Sök efter reservdelar",
  "Confirm": "Bekräfta",
  "Ordercode too short": "Beställningskod för kort",
  "Product status": "Produktens status",
  "Open": "Öppna",
  "Clear": "Klar",
  "PDF file with assembly instructions": "PDF-fil med monteringsanvisningar",
  "Search products": "Sök produkter",
  "Export": "Export",
  "Production date": "Produktionsdatum",
  "Order stop": "Orderstopp",
  "Calibration until": "Kalibrering tills",
  "PDF file with compatibility information": "PDF-fil med information om kompatibilitet",
  "Add selection to cart": "Lägg till urval i varukorgen",
  "Mounting advices": "Råd om montering",
  "Recommended parts only": "Endast rekommenderade delar",
  "not applicable": "ej tillämpligt",
  "accessories": "Tillbehör",
  "Cumulative spare parts list": "Kumulativ reservdelslista",
  "YYYY": "ÅÅÅÅ",
  "Title": "Titel",
  "Error": "Fel",
  "Ordercode too long": "Beställningskod för lång",
  "Functions": "Funktioner",
  "Rec": "Rek",
  "Type": "Typ",
  "Spare sensor until": "Reservsensor tills",
  "Spare parts until": "Reservdelar fram till",
  "Filter": "Filter",
  "Check all": "Kontrollera alla",
  "Order code": "Beställningskod",
  "Repair until": "Reparation tills",
  "Tag": "Tagg",
  "Ok": "Ok",
  "Category code": "Kategori kod",
  "Phase out": "Fasa ut",
  'Compatibility advices': 'Ytterligare dokument',
  'Co.': 'Ytterl. dok.',
} as LocalizedDictionary;
